const UNITS = { piece:'шт', liter:'л', gram:'кг' };

export default function CartItem({ item, onUpdate, onRemove }) {
  if (item.is_free) {
    return (
      <div style={{...styles.wrap, border:'1px solid #2d6a4f', background:'#0d2818'}}>
        <div style={styles.nameRow}>
          <span style={{...styles.name, color:'#5fbf8f'}}>{item.product_name}</span>
          <span style={{color:'#5fbf8f', fontSize:'11px', background:'#1a4a2a', padding:'2px 8px', borderRadius:'10px'}}>
            АКЦІЯ
          </span>
        </div>
        <div style={styles.row}>
          <span style={{color:'#9a8a6e', fontSize:'13px', flex:1}}>
            {item.quantity.toFixed(item.unit==='piece'?0:item.unit==='gram'?3:1)} {item.unit==='gram'?'кг':item.unit==='liter'?'л':'шт'}
          </span>
          <span style={{color:'#5fbf8f', fontWeight:'bold', fontSize:'14px'}}>0.01 ₴</span>
        </div>
      </div>
    );
  }
  const step = item.unit === 'piece' ? 1 : item.unit === 'liter' ? 0.5 : 0.1;
  const total = (parseFloat(item.price) * item.quantity).toFixed(2);

  function changeQty(delta) {
    const newQty = Math.round((item.quantity + delta) * 1000) / 1000;
    if (newQty <= 0) { onRemove(item.cartKey); return; }
    if (newQty > item.stock_quantity) return;
    onUpdate(item.cartKey, newQty);
  }

  function handleInput(val) {
    const num = parseFloat(val);
    if (isNaN(num) || num <= 0) { onRemove(item.cartKey); return; }
    const clamped = Math.min(Math.round(num * 1000) / 1000, item.stock_quantity);
    onUpdate(item.cartKey, clamped);
  }

  const displayQty = item.unit === 'piece'
    ? item.quantity.toFixed(0)
    : item.unit === 'liter'
    ? item.quantity.toFixed(1)
    : item.quantity.toFixed(3);

  return (
    <div style={styles.wrap}>
      <div style={styles.nameRow}>
        <span style={styles.name}>{item.product_name}</span>
        <button style={styles.remove} onClick={() => onRemove(item.cartKey)}>✕</button>
      </div>
      <div style={styles.row}>
        <button style={styles.btn} onClick={() => changeQty(-step)}>−</button>
        <input
          style={styles.qtyInput}
          type="number"
          step={step}
          min={step}
          value={displayQty}
          onChange={e => handleInput(e.target.value)}
        />
        <span style={styles.unit}>{UNITS[item.unit]}</span>
        <button style={styles.btn} onClick={() => changeQty(step)}>+</button>
        <div style={styles.priceCol}>
          <span style={styles.unitPrice}>{parseFloat(item.price).toFixed(2)} ₴/{UNITS[item.unit]}</span>
          <span style={styles.total}>{total} ₴</span>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { background:'#211c14', borderRadius:'8px', padding:'8px 10px', marginBottom:'6px', border:'1px solid #38301f' },
  nameRow: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px' },
  name: { fontSize:'13px', fontWeight:'bold', flex:1 },
  row: { display:'flex', alignItems:'center', gap:'5px' },
  btn: { width:'28px', height:'28px', background:'#38301f', color:'#fff', border:'none', borderRadius:'6px', cursor:'pointer', fontSize:'18px', lineHeight:1, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
  qtyInput: { width:'60px', padding:'4px 6px', borderRadius:'6px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'13px', textAlign:'center' },
  unit: { color:'#9a8a6e', fontSize:'12px', minWidth:'20px' },
  priceCol: { flex:1, textAlign:'right', display:'flex', flexDirection:'column', gap:'1px' },
  unitPrice: { color:'#9a8a6e', fontSize:'11px' },
  total: { color:'#f5a623', fontWeight:'bold', fontSize:'15px' },
  remove: { background:'transparent', border:'none', color:'#9a8a6e', cursor:'pointer', fontSize:'13px', padding:'0', flexShrink:0 },
};
